import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import Home from '../views/School/home.vue';

import app from '../js/app.js';
import roleHelper from '../js/roleHelper.js';
import config from '../js/config.js';

import routerCourse from './router.course';
import routerCenter from './router.center';
import routerTeachingMaterial from './router.teaching.material';

import routerSchool from './router.school';

Vue.use(VueRouter);
const allowUnLoginPaths = ['/', '/login', '/forget-password', '/change-password'];
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: string): any {
    return (originalPush.call(this, location) as any).catch((err: any) => err);
};
const routes: Array<RouteConfig> = [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home,
    // redirect: "/school/account/account_center"
    // },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        redirect: '/school/statistics/customerData'
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/About.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/forget-password',
        name: 'forget-password',
        component: () => import('../views/forget-password.vue')
    },
    {
        path: '/change-password',
        name: 'change-password',
        component: () => import('../views/change-password.vue')
    }
];

const addRoutes = function (_routes: any) {
    if (!_routes) {
        console.error('addRoutes:参数错误');
    } else if (_routes.length === undefined) {
        routes.push(_routes);
    } else if (typeof _routes == 'object' && _routes.length > 0) {
        for (let i = 0; i < _routes.length; i++) {
            routes.push(_routes[i]);
        }
    }
};

addRoutes(routerCourse.routes);
addRoutes(routerCenter.routes);
addRoutes(routerTeachingMaterial.routes);

addRoutes(routerSchool.routes);

const router = new VueRouter({
    mode: 'history',
    routes
});

//路由导航守卫
router.beforeEach((to, from, next) => {
    let loginPath = '/login';
    if (to.path == '/') {
        return next(loginPath);
    }

    //demo不拦截
    let entrance = app.getUrlRootName(to.path);
    if (entrance == 'demo') {
        return next();
    }

    /****************未登录不拦截的处理****************/
    for (var i = 0; i < allowUnLoginPaths.length; i++) {
        if (to.path === allowUnLoginPaths[i]) {
            console.log('【路由导航守卫】对页面【' + allowUnLoginPaths[i] + '】不拦截');
            return next();
        }
    }

    /****************登录校验****************/
    const whetherLand = app.whetherLand();
    if (!whetherLand) {
        console.error('【路由导航守卫】拦截页面【' + to.path + '】,理由:未登录');
        return next(loginPath);
    }

    /****************判断入口与登录信息是否一致****************/
    let state: any = app.getState();
    let allowLogin = roleHelper.allowLogin(state.roles);
    if (!allowLogin) {
        let userRoleNames = roleHelper.getRoleNames(state.roles);
        let allowLoginRoleNames = roleHelper.getRoleNames(config.allowRoles);
        console.error('【路由导航守卫】拦截页面【' + to.path + '】,理由:角色与入口不匹配');
        console.error('【路由导航守卫】平台允许', allowLoginRoleNames, '当前登录角色', userRoleNames);

        alert('当前登录用户与角色入口不匹配');
        return;
    }
    next();
});

export default router;
